export { default as main } from '@components/main/main.route';
export { default as update } from '@components/update/update.route';
